var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component_type,{directives:[{name:"tooltips-enabled",rawName:"v-tooltips-enabled",value:({
                    active:_vm.tooltip,
                    title:_vm.title
                }),expression:"{\n                    active:tooltip,\n                    title:title\n                }"}],tag:"component",staticClass:"btn-floating-responsive btn-floating btn-floating-single waves-effect waves-light",class:[
        {
        'btn-floating-small':_vm.small
        },
        _vm.cls,

        _vm.btn_type

        ],on:{"click":function($event){_vm.click()}}},[_vm._t("content")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a54d640","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/Shared/Resources/Assets/js/components/base/buttons/BaseButtonRound.vue
// module id = 85Mt
// module chunks = 0